/**
 * Utilidades de acceso B2B — catálogo privado y roles.
 */

export const isAuthenticated = () => !!localStorage.getItem('accessToken')

export const isAdmin = () => localStorage.getItem('isAdmin') === 'true'

export const isDistributor = () => localStorage.getItem('isDistributor') === 'true'

export const getUserRole = () => localStorage.getItem('userRole') || 'retail'

const readCachedPermissions = () => {
  try {
    const raw = localStorage.getItem('userPermissions')
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

/** Catálogo retail en kameseeds.com: acceso público sin login. */
export const canAccessCatalog = () => true

/** Tienda ingreso.kameseeds.com: requiere sesión y cuenta aprobada (o admin). */
export const canAccessIngresoShop = () => {
  if (!isAuthenticated()) return false
  if (isAdmin()) return true
  return localStorage.getItem('isApproved') === 'true'
}

export const canAccessWholesale = () => {
  if (isAdmin()) return true

  const cached = readCachedPermissions()
  if (cached?.permissions?.can_access_wholesale) return true
  if (cached?.is_wholesale || cached?.is_distributor) return true

  return isDistributor()
}

export const syncAuthFlags = (user = {}) => {
  if (user.is_staff || user.is_superuser) {
    localStorage.setItem('isAdmin', 'true')
  } else {
    localStorage.removeItem('isAdmin')
  }

  if (user.is_approved) {
    localStorage.setItem('isApproved', 'true')
  } else {
    localStorage.removeItem('isApproved')
  }

  const wholesale = Boolean(
    user.is_distributor ||
    user.is_wholesale ||
    user.permissions?.can_access_wholesale
  )
  if (wholesale) {
    localStorage.setItem('isDistributor', 'true')
  } else {
    localStorage.removeItem('isDistributor')
  }

  if (user.role) {
    localStorage.setItem('userRole', user.role)
  } else {
    localStorage.removeItem('userRole')
  }
}

export const clearAuthFlags = () => {
  localStorage.removeItem('isAdmin')
  localStorage.removeItem('isDistributor')
  localStorage.removeItem('userRole')
  localStorage.removeItem('isApproved')
}
